import styled from "@emotion/styled";
import { Layout } from "antd";
import { genericStyles } from "../../../constant";

const { Header, Sider, Content } = Layout;

export const StyledLayout = styled(Layout)`
  height: 100dvh;
  overflow: hidden;
`;

export const StyledContent = styled(Content)`
  margin-left: ${(props) =>
    // @ts-ignore
    props.sidebarCollapsed ? "70px" : "260px"};
  padding: 10px 10px 0px 10px;
  background: ${genericStyles.outsideBgColor};
  min-height: 100dvh;
  overflow-y: auto;
  transition: margin-left 0.3s ease;
  @media (max-width: 767px) {
    margin-left: 0px;
    padding: 10px;
    margin-top: 64px;
  }
`;

// ------- Start Top bar Styles --------

export const StyledHeader = styled(Header)`
  position: fixed;
  top: 0;
  right: 0;
  left: ${(props) =>
    // @ts-ignore
    props.sidebarCollapsed ? "70px" : "260px"};
  z-index: 99;
  background: var(--primary);
  color: white;
  border-bottom: 1px solid #f0f0f0;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 64px;
  box-shadow: ${genericStyles.boxShadow};
  transition: left 0.3s ease;
  @media (max-width: 767px) {
    left: 0px;
  }
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  .ant-select-content-value,
  .ant-select-placeholder,
  .ant-select-suffix {
    color: white !important;
  }
  .ant-avatar {
    background: white !important;
    color: var(--primary);
  }
  @media (max-width: 767px) {
    flex-direction: row-reverse;
  }
`;

export const ToggleButton = styled.div`
  cursor: pointer;
  /* padding: 8px; */
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  .anticon {
    font-size: 16px;
    color: white;
  }
`;

// ------- End Top bar Styles --------

// ------- Start Side bar Styles --------
export const StyledSideBar = styled(Sider)`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 100;
  height: 100dvh;
  overflow-y: auto;
  background: var(--primary);
  box-shadow: ${genericStyles.boxShadow};

  .sidebar-title,
  .ant-menu-submenu-title {
    color: white !important;
  }
  .sidebar-header {
    gap: 10px;
  }
  .ant-menu {
    border-right: none;
    background: var(--primary);
    .ant-menu-item-icon {
      color: white !important;
    }
  }
  .ant-menu-item-selected {
    background: var(--linear-bg);
    border: 1px solid white !important;
    color: white;
  }

  .ant-menu-item {
    display: flex;
    align-items: center;
    padding: 0 24px;
    font-weight: bolder;
    color: white !important;

    .anticon {
      font-size: 16px;
      margin-right: ${(props) => (props.collapsed ? "0" : "12px")};
    }

    .menu-text {
      opacity: ${(props) => (props.collapsed ? "0" : "1")};
      transition: opacity 0.3s ease;
    }
  }
  .ant-menu-vertical .anticon,
  .ant-menu-submenu-vertical .ant-menu-submenu-title .ant-menu-item-icon {
    display: flex;
    justify-content: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    font-size: 18px;
  }
  .ant-menu-submenu-title {
    .more-icon {
      background: white !important;
      color: var(--primary) !important;
    }
  }

  .more-menu {
    .ant-menu-submenu-vertical {
      .ant-menu-submenu-title {
        .ant-menu-item-icon {
          margin-left: 12px;
          margin-top: 5px;
          background: white !important;
          color: var(--primary) !important;
        }
      }
    }
  }
`;

export const Logo = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 64px;
  overflow: hidden;
  font-size: 18px;
  font-weight: bold;
  .logo-text {
    opacity: ${(props) =>
      // @ts-ignore
      props.collapsed ? "0" : "1"};
    transition: opacity 0.3s ease;
    margin-left: 8px;
  }
  img {
    height: 45px;
    width: 45px;
  }
`;

export const SidebarContent = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`;

export const MenuSection = styled.div`
  padding: 8px 16px;
  font-size: 11px;
  font-weight: 500;
  color: #d5cfcf;
  letter-spacing: 1px;
  text-transform: uppercase;
  margin-top: 8px;
`;
// ------- End Side bar Styles --------
